import React, { useEffect, useState } from "react";
import Header from "../../components/Header";
import ModalConfirmLogout from "../../components/ModalConfirmLogout";
import TableCard from "../../components/TableCard";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import BackgroundVideo from "components/BackgroundVideo";

export default function BaccaratRoomList() {
  // CSS cho animation shake
  React.useEffect(() => {
    const style = document.createElement("style");
    style.textContent = `
      @keyframes flash-bounce {
        0%, 100% { 
          transform: scale(1) translateY(0);
          filter: brightness(1);
        }
        25% { 
          transform: scale(1.1) translateY(-3px);
          filter: brightness(1.5);
        }
        50% { 
          transform: scale(1.2) translateY(-5px);
          filter: brightness(2);
        }
        75% { 
          transform: scale(1.1) translateY(-3px);
          filter: brightness(1.5);
        }
      }
    `;
    document.head.appendChild(style);
    return () => {
      if (document.head.contains(style)) {
        document.head.removeChild(style);
      }
    };
  }, []);

  const [isShowLogout, setIsShowLogout] = useState(false);
  const [dataRoom, setDataRom] = useState<any>([]);
  const [bridgeDataAll, setBridgeDataAll] = useState<{ [key: string]: any }>(
    {}
  );
  const Cookies = require("js-cookie");
  const navigate = useNavigate();
  const [coins, setCoins] = useState(0);

  const token = Cookies.get("access_token");
  const user_infor = localStorage.getItem("user_info");

  useEffect(() => {
    if (user_infor) {
      const test = JSON.parse(user_infor);
      setCoins(test.coins);
    }
  }, [user_infor]);

  // Fetch bridge data real-time cho tất cả bàn
  useEffect(() => {
    const fetchBridgeDataForTable = async (tableName: string) => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_URL_API_CASINO}/predict/get-table-by-name?tableName=${tableName}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        return { tableName, data: response.data };
      } catch (err) {
        console.log(`Bridge ${tableName} data fetch error:`, err);
        return { tableName, data: null };
      }
    };

    const fetchAllBridgeData = async () => {
      if (dataRoom.length === 0) return;

      const promises = dataRoom.map((room: any) =>
        fetchBridgeDataForTable(room.tableName)
      );

      const results = await Promise.all(promises);
      const newBridgeData: { [key: string]: any } = {};

      results.forEach(({ tableName, data }) => {
        if (data) {
          newBridgeData[tableName] = data;
        }
      });

      setBridgeDataAll(newBridgeData);
    };

    // Fetch ngay lập tức
    fetchAllBridgeData();

    // Polling mỗi 2 giây để update data mới
    const interval = setInterval(fetchAllBridgeData, 2000);

    return () => clearInterval(interval);
  }, [token, dataRoom]);

  const handleClick = (value: any) => {
    if (coins !== 0) {
      navigate(`/casino/room/${value.tableName}`);
    } else {
      Swal.fire({
        icon: "error",
        title: "Lỗi tải dữ liệu",
        text: "Vui lòng nạp thêm xu vào tài khoản!",
        customClass: {
          popup: "bg-custom-image text-white",
        },
      });
    }
  };

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (dataRoom.length === 0) {
      setIsLoading(true);
      Swal.fire({
        title: "♠️ Đang tải dữ liệu trò chơi",
        html: `
          <div class="loading-container">
            <div class="loading-spinner"></div>
            <p class="loading-text">Vui lòng chờ trong giây lát...</p>
            <div class="loading-progress">
              <div class="loading-bar"></div>
            </div>
          </div>
        `,
        timerProgressBar: true,
        allowOutsideClick: false,
        showConfirmButton: false,
        customClass: {
          popup: "loading-modal-popup",
          title: "loading-modal-title",
          htmlContainer: "loading-modal-content",
        },
        background:
          "linear-gradient(135deg, #1a1a1a 0%, #2d1b1b 50%, #1a1a1a 100%)",
        color: "#ffffff",
        willOpen: () => {
          Swal.showLoading();
        },
      });
      const timeout = setTimeout(() => {
        axios
          .get(
            `${process.env.REACT_APP_URL_API_CASINO}/predict/get-all-table`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          )
          .then((data) => setDataRom(data.data))
          .catch((err) => console.log(err));
      }, 1000); // Delay 1 giây

      return () => clearTimeout(timeout);
    } else {
      setIsLoading(false);
      Swal.close();
    }
  }, [dataRoom, token]);

  return (
    <div
      className="h-screen relative overflow-x-hidden bg-scroll bg-no-repeat w-full"
      // style={{
      //   backgroundImage: `url('/assets/bg-new.png')`,
      // }}
    >
      <BackgroundVideo />
      <Header setIsShowLogout={() => setIsShowLogout(true)} />
      <div className="md:py-16 py-[60px]" />

      <div className="container-fluid lobby-bg position-relative mx-auto mb-5 max-w-screen-xl px-2 sm:px-4 overflow-hidden">
        <div className="container mx-auto py-6 sm:py-8 md:py-10 px-1 sm:px-2 md:px-4 max-w-full">
          <div className="flex flex-wrap justify-center items-center mb-4 sm:mb-6">
            <div className="w-2/3 sm:w-1/2 md:w-2/3">
              <img
                src="/assets/bcr-sexy.png"
                alt="bcr-sexy"
                className="h-12 sm:h-16 md:h-20 lg:h-28 w-auto"
              />
            </div>

            <div className="w-1/3 sm:w-1/2 md:w-1/3 flex justify-center items-center">
              <a href="/casino" className="mt-12 sm:mt-0">
                <img
                  src="/assets/back.png"
                  alt="Quay lại"
                  className="h-8 sm:h-10 md:h-12 cursor-pointer hover:opacity-80 transition-opacity"
                />
              </a>
            </div>
          </div>

          {/* Danh sách các bàn */}
          {!isLoading && (
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              {dataRoom
                .sort((a: any, b: any) => {
                  const aName = a.tableName || "";
                  const bName = b.tableName || "";

                  // Extract C01-C16 tables first
                  const aIsC = aName.match(/^C(\d+)$/);
                  const bIsC = bName.match(/^C(\d+)$/);

                  if (aIsC && bIsC) {
                    // Both are C tables, sort by number
                    return parseInt(aIsC[1]) - parseInt(bIsC[1]);
                  } else if (aIsC && !bIsC) {
                    // A is C table, B is not - A comes first
                    return -1;
                  } else if (!aIsC && bIsC) {
                    // B is C table, A is not - B comes first
                    return 1;
                  } else {
                    // Neither are C tables, maintain original order
                    return 0;
                  }
                })
                .map((e: any) => (
                  <TableCard
                    key={e.id}
                    tableName={e.tableName}
                    tableData={bridgeDataAll[e.tableName]}
                    onClick={() => handleClick(e)}
                  />
                ))}
            </div>
          )}
        </div>
        <ModalConfirmLogout
          isShowLogout={isShowLogout}
          setIsShowLogout={() => {
            setIsShowLogout(false);
          }}
        />
      </div>
    </div>
  );
}
